import { combineReducers } from 'redux';
import types from './types';

export const account = (state = {
  item: null,
  loading: false,
  error: null,
}, action) => {
  // console.log('::::::REDUCER::ACCOUNTS::account::', action);
  switch (action.type) {
    case types.GET_REQUEST:
    case types.SAVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GET_FAILURE:
    case types.SAVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.CLEAR_CURRENT:
    case types.SAVE_SUCCESS:
      return {
        ...state,
        item: null,
        loading: false,
        error: null,
      };
    case types.GET_SUCCESS:
      return {
        ...state,
        item: action.payload.data,
        loading: false,
        error: null,
      };
    default:
      return state
  }
}


export const accounts = (state = {
  loading: false,
  items: null,
  items_account_users:null,
  error: null,
}, action) => {
  // console.log('::::::REDUCER::ACCOUNTS::accounts::', action);
  switch (action.type) {
    case types.GETALL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GETALL_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.data,
        query: action.payload.query,
      };
    case types.GETALL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case types.DELETE_REQUEST:
      return {
        ...state,
        items: state.items.map((item) =>
          item.id === action.id ? { ...item, deleting: true } : item
        ),
      };
    case types.DELETE_SUCCESS:
      // remove deleted item from state
      return {
        ...state,
        items: state.items.filter((item) => item.id !== action.id),
      };
    case types.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to item
      return {
        ...state,
        items: state.items.map((item) => {
          if (item.id === action.id) {
            // make copy of product without 'deleting:true' property
            const { deleting, ...itemCopy } = item;
            // return copy of product with 'deleteError:[error]' property
            return { ...itemCopy, deleteError: action.error };
          }

          return item;
        }),
      };
    case types.GETALL_ACCOUNTS_USERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.GETALL_ACCOUNTS_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        items_account_users: action.payload.data,
        query: action.payload.query,
      };
    case types.GETALL_ACCOUNTS_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}


export default combineReducers({
  current: account,
  list: accounts
});

